import { getEnv } from './environments';
import { Environment, globalConfig } from './globalConfig';

const language = globalConfig.language || 'en';

/**
 * Pages under Nautilus projects
 *
 * All routes here needs to physically exist on portal BE,
 * since they need pass through the currently active
 * studio/performer id.
 */
export const nautilusRedirectRoutes = {
    holidayAwards: `/${language}/bestof/holiday-awards`,
    myAccounts: `/${language}/my-accounts`,
    scheduledShows: `/${language}/scheduled-shows`,
    settings: `/${language}/settings`,
    performance: `/${language}/performance/traffic-score`,
    servicesAgreementUpdate: `/${language}/services-agreement-update`,
    statisticsPayingMembersNotes: (memberId: number) => `/${language}/statistics/paying-members/${memberId}/notes`,
};

/**
 * Routes that must be used with the nautilus domain directly, not with a redirect through legacy portal.
 */
export const nautilusNoRedirectRoutes = {
    landing: `/${language}?forceShow=1`,
};

const nautilusDomainByEnv: {
    [env in Environment]: string;
} = {
    [Environment.DEV]: 'https://msc-backoffice-livejasmin.dev.k8sdevel.com',
    [Environment.STAGING]: 'https://lubet-new.modelcenter.livejasmin.com',
    [Environment.PROD]: 'https://new.modelcenter.livejasmin.com',
};

const currentEnvironment = getEnv();

/**
 * Returns the Nautilus domain matching the current environment.
 * Note: On dev, this will return the shared dev domain, not the developer's dev domain.
 */
export const getNautilusDomain = () => nautilusDomainByEnv[currentEnvironment];
